import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var DownloadAlt = function DownloadAlt(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M29.176 11.294h-7.529v-11.294h-11.294v11.294h-7.529l13.176 13.176 13.176-13.176zM2.823 28.235v3.765h26.353v-3.765h-26.353z"
  }));
};
export default DownloadAlt;